import { Money } from "models/money";
import { Unit } from "models/unit";

export function getExcelData(
  companiesCatalog,
  selectedCompanyId1,
  companyData1,
  selectedCompanyId2,
  companyData2
) {
  let rows = [];

  const selectedCompany1Name = selectedCompanyId1
    ? companiesCatalog.filter((e) => e.id === selectedCompanyId1)[0].name
    : "";
  const selectedCompany2Name = selectedCompanyId2
    ? companiesCatalog.filter((e) => e.id === selectedCompanyId2)[0].name
    : "";

  const bigger = Math.max(companyData1.length, companyData2.length);
  for (let i = 0; i < bigger; i++) {
    let company1 = null;
    let company2 = null;
    try {
      company1 = companyData1[i];
    } catch {
      company1 = null;
    }

    try {
      company2 = companyData2[i];
    } catch {
      company2 = null;
    }

    var _known = {
      Empresa: company1 ? selectedCompany1Name : "",
      Nombre: company1 ? company1.productName.split("-")[0] : "",
      Presentacion: company1 ? company1.productPresentation : "",
      "Unidades Total": company1 ? Unit(company1.totalQuantity) : "",
      "USD Total": company1 ? Money(company1.totalSales) : "",
      Detalles: company1 ? company1.productName : "",
      "  ": "<-->",
      "Empresa.": company2 ? selectedCompany2Name : "",
      "Nombre.": company2 ? company2.productName.split("-")[0] : "",
      "Presentacion.": company2 ? company2.productPresentation : "",
      "Unidades Total.": company2 ? Unit(company2.totalQuantity) : "",
      "USD Total.": company2 ? Money(company2.totalSales) : "",
      "Detalles.": company2 ? company2.productName : "",
    };
    rows.push(_known);
  }

  return rows;
}
